import { useCallback } from 'react';

import { getAccountContextForHistory } from '@routes/utils';
import { useAppSelector } from '@store/hooks';
import { selectAccountContextFromAccount } from '@store/reducers/reducer-auth';
import { useNavigator } from '@components/router';

export interface NavigateOptions {
  /**
   * Prefix the path with the active account context; defaults to `true`.
   */
  useContext?: boolean;
}

/**
 * Programmatic navigation that prefixes the active account context by default,
 * so callers get Link's behavior without repeating the context plumbing.
 */
export const useNavigate = () => {
  const navigator = useNavigator();
  const accountContext = useAppSelector(selectAccountContextFromAccount);

  return useCallback(
    (to: string, { useContext = true }: NavigateOptions = {}) => {
      const context = useContext
        ? getAccountContextForHistory(accountContext)
        : '';

      navigator.push(`${context}${to}`);
    },
    [navigator, accountContext],
  );
};
